import { styled } from '@shared/theme';

const FullContentContainer = styled('div')(({ spacing, palette }) => ({
  padding: spacing(5),
  backgroundColor: palette.common.white,
  height: '100%',
  flex: '1 1 auto',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
}));

export default FullContentContainer;
